// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-dAI","content":"styles_content__3uG5k"};